export { default } from "./ScmConfig";

export enum Provider {
  GITHUB_APP = "GITHUB_APP",
  GITLAB = "GITLAB"
}
